import React from 'react'
import {Container, Row,Col} from "react-bootstrap"
import {Link} from 'react-router-dom'
import parse from "html-react-parser";

function MobileQuestionSearch({questionData,onClick}) {
    return (
        <>
            <div onClick={onClick}>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <div className="mb-2 border-b border-solid border-gray-300">
                                <a href={`http://wisemonkeys.info/questions/${questionData.slug}`} className="no-underline text-black">
                                    <span className="manpro">{questionData.question_title && parse(questionData.question_title)}</span>
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>   
        </>
    )
}

export default MobileQuestionSearch
